import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "list-label-value-component" };
const _hoisted_2 = {
    key: 0,
    class: "v2-title--small-2 mb-3"
};
const _hoisted_3 = { class: "v2-text--mini-2 text-black" };
const _hoisted_4 = { class: "v2-text--mini text-v2-secondary" };
const _hoisted_5 = { key: 1 };
export default /*@__PURE__*/ _defineComponent({
    __name: 'list-label-value',
    props: {
        items: {},
        title: { default: null }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (props.title)
                    ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(props.title), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "list-label-value-component--rows"
                        }, [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(item.href ? 'a' : 'div'), {
                                href: item.href || null,
                                target: item.href ? '_blank' : null,
                                class: "list-label-value-component--row"
                            }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1),
                                    _createElementVNode("span", _hoisted_4, [
                                        (typeof item.value === 'object')
                                            ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.value), { key: 0 }))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.value), 1))
                                    ])
                                ]),
                                _: 2
                            }, 1032, ["href", "target"]))
                        ]));
                    }), 128))
                ])
            ]));
        };
    }
});
